import chunk from 'lodash/chunk';
import React from 'react';
import { Hover } from '../../components/behavior/Hover';
import { Row } from '../../components/Grid';
import {
  NavigationLink,
  NavigationListItem,
  NavigationListItemWithTriangle,
  NavigationWrapper
} from '../../components/Navigation';
import { getSvgIconKey, SvgIcon } from '../../components/SvgIcon';
import { selectVehicleCenters } from '../../provider/Typo3Provider/selectors';
import { MenuEntry } from '../../provider/Typo3Provider/types';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import { countryCodeMapping } from '../../utils/countryCodeMappings';
import VehicleCenterColumns from './VehicleCenterColumns';

interface LocationsProps {
  entriesPerColumn: number;
  locationEntries: MenuEntry[];
  countryEntries: MenuEntry[];
}

const Locations = ({
  typo3,
  entriesPerColumn,
  locationEntries,
  countryEntries
}: LocationsProps & WithTypo3Props) => {
  const [mainEntry] = locationEntries;
  const columns = chunk(countryEntries, entriesPerColumn);
  const numColumns = columns.length;
  const vehicleCenters = selectVehicleCenters(typo3);
  const hoverContent = (
    <Row noGap>
      <VehicleCenterColumns entriesPerColumn={entriesPerColumn}>
        {countryEntries.map(countryEntry => {
          const { uid, title, icon } = countryEntry;
          const iconKey = getSvgIconKey(icon || '');
          const countryCode = iconKey
            ? countryCodeMapping[iconKey as keyof typeof countryCodeMapping]
            : null;
          const locations = vehicleCenters.filter(
            vehicleCenter => vehicleCenter.countryCode === countryCode
          );
          if (locations.length === 0) {
            return null;
          } else {
            const link =
              locations.length === 1 ? locations[0].link : countryEntry.link;
            return (
              <NavigationListItem key={uid}>
                {/* #39185: preventing wrapping of cloumns */}
                <NavigationLink to={link} style={{ paddingRight: 0 }}>
                  {iconKey && <SvgIcon icon={iconKey} />}
                  {title}
                </NavigationLink>
              </NavigationListItem>
            );
          }
        })}
      </VehicleCenterColumns>
    </Row>
  );
  return (
    <Hover
      timeout={250}
      render={({ hover, hoveredBefore, ...hoverProps }) => (
        <NavigationListItemWithTriangle
          key={mainEntry.uid}
          showTriangle={hover}
          {...hoverProps}
        >
          <NavigationLink to={mainEntry.link}>
            <span>{mainEntry.title}</span>
          </NavigationLink>
          {hover && (
            <NavigationWrapper
              // prevent wrapping of columns in IE11 #39185
              width={numColumns > 1 ? 600 : undefined}
              {...hoverProps}
            >
              {hoverContent}
            </NavigationWrapper>
          )}
        </NavigationListItemWithTriangle>
      )}
    />
  );
};

export default withTypo3(Locations);
